var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Close Icon - White") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close-Icon---White",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#006699",
    points: "15.9004762 14.2321429 20.7321429 20.2554762 20.2554762 20.7321429 14.2321429 15.9004762 8.20880952 20.7321429 7.73214286 20.2554762 12.5638095 14.2321429 7.73214286 8.20880952 8.20880952 7.73214286 14.2321429 12.5638095 20.2554762 7.73214286 20.7321429 8.20880952"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#ACACAC",
    opacity: 0.600000024,
    cx: 14,
    cy: 14,
    r: 14
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.02da70c22292b207943c2882ac6c747e.svg";
export { ForwardRef as ReactComponent };